<template>
  <v-form
    :lazy-validation="true"
    @submit.prevent="handleSubmit"
    v-model="valid"
  >
    <v-card>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>{{ $t("common.create") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          :label="$t('application.fields.name')"
          name="name"
          prepend-icon="mdi-domain"
          type="text"
          v-model="name"
          :rules="nameRules"
        ></v-text-field>
      </v-card-text>

      <v-card-text>
        <company-selector v-model="sharedCompanies" />
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" type="submit" x-large>{{
          $t("common.create")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CompanySelector from "../company/CompanySelector.vue";
export default {
  name: "ApplicationCreate",
  components: { CompanySelector },
  data() {
    return {
      submitted: false,
      valid: false,
      name: "",
      sharedCompanies: [],
      nameRules: [
        (v) => !!v || this.$t("application.validation.nameRequired"),
        (v) =>
          (v && v.length <= 255) || this.$t("application.validation.nameMax"),
      ],
    };
  },
  computed: {
    ...mapState("users", [
      "status",
      "currentUser",
      "userCompany",
      "hasCompany",
    ]),
  },
  methods: {
    ...mapActions("applications", ["createApplication"]),
    handleSubmit() {
      this.submitted = true;

      const { name } = this;

      if (name)
        this.createApplication({
          applicationPayload: {
            name: name,
            sharedCompanies: this.sharedCompanies,
          },
        }).then(() => {
          this.$router.push("/application");
        });
    },
  },
  created() {
    if (!this.hasCompany) this.$router.push("/company/create");
  },
};
</script>

<style>
</style>